/* SEO — per-page meta tags. Drop <SEO title="..." description="..." /> at the
   top of any public page to give it a unique <title> and <meta name="description"> .
   Wraps react-helmet-async (HelmetProvider lives in App.js). */
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Clinq Prep";
const DEFAULT_DESC =
  "Clinq Prep helps African founders build funder-ready pitch decks, financial models, and management accounts — tailored to your business, stage and industry.";
const SITE_ORIGIN = "https://prep.clinq.africa";

export default function SEO({
  title,
  description = DEFAULT_DESC,
  path = "",
  noindex = false,
  image = `${SITE_ORIGIN}/og-card.png`,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Get your business funder-ready`;
  const url = `${SITE_ORIGIN}${path || ""}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
